module.exports = __webpack_public_path__ + "static/media/laptop.cc4505e4.jpg";